/**
 * Eventos de dominio que el módulo Cartera Inteligente puede emitir hacia
 * sistemas externos del cliente (modo co-pilot e híbrido).
 *
 * Cada evento se nombra como `recurso.accion` siguiendo convención de Stripe.
 * El payload viaja como JSON firmado con HMAC SHA256 en el header
 * `X-Cartera-Signature`. El secret se configura en `tenant_webhook_endpoints`.
 */
export const EVENTOS_CARTERA = [
  'gestion.registrada',
  'promesa.creada',
  'promesa.cumplida',
  'promesa.incumplida',
  'cobro.registrado',
  'campana.enviada',
  'recomendacion.alta_prioridad',
] as const;

export type EventoCarteraValor = (typeof EVENTOS_CARTERA)[number];
